<template lang="pug">
div(v-bind="stylesData.container")
  .gap-16.pb-6.text-center.full-width.d-flex.overflow-x-auto.redesign-scrollbar
    div.relative(
      v-for="(image, idx) in images"
      :key="idx"
    )
      v-img.pointer(
        :src="image.thumb || image.url"
        :lazy-src="placeholder"
        :aspect-ratio="aspectRatio"
        v-bind="stylesData.image"
        @click="showImageDialog(image)"
      )
      app-button.action-button.absolute.top-0.right-0.rounded-8(
        v-if="!hideActions"
        x-small
        v-bind="stylesData.buttons.remove.attrs"
        color="white"
        @click.prevent="$emit('deleteImage', image, idx)"
      )
        v-icon(color="redesignError" v-bind="stylesData.buttons.remove.icon") $itrash
      template(v-if="showMain")
        app-button.white--text.mt-2.rounded-8(
          v-if="mainCondition(image, idx)"
          x-small
          color="redesignPrimary"
          height="30px"
          block
        )
          .body-2 Главная
        app-button.redesignPrimary--text.mt-2.rounded-8(
          v-else
          x-small
          color="white"
          height="30px"
          block
          outlined
          @click="$emit('makeMain', image, idx)"
        )
          .body-2 Сделать главной

  redesign-image-dialog(
    :show-dialog="!!activeImage"
    :images="[activeImage]"
    :showImageDialog="true"
    @close="closeImageDialog"
  )
</template>

<script>
import RedesignImageDialog from '@/components/user-redesign/image-slider/ImageDialog.vue';
import AppButton from '@/components/user-redesign/controls/AppButton.vue';
import placeholder from '@/assets/placeholder.jpg';

export const LIST_STYLE = {
  default: 0,
  borderless: 1,
};

export default {
  name: 'ImagesList',
  components: {
    RedesignImageDialog,
    AppButton,
  },
  props: {
    images: { type: Array, default: () => [] },
    aspectRatio: { type: Number, default: 16 / 9 },
    listStyle: { type: Number, default: LIST_STYLE.default },
    showMain: { type: Boolean, default: true },
    hideActions: { type: Boolean, default: false },
    mainCondition: { type: Function, default: (image) => image.is_main },
  },
  data() {
    return {
      placeholder,
      activeImage: null,
    };
  },
  computed: {
    stylesData() {
      return {
        [LIST_STYLE.default]: {
          container: {
            class: 'redesign-border pa-6 pb-4',
          },
          image: {
            class: 'rounded-8',
            width: 140,
          },
          buttons: {
            remove: {
              attrs: {
                height: 24,
                width: 24,
                'min-width': 24,
                class: 'ma-1',
              },
              icon: {
                size: 12,
              },
            },
          },
        },
        [LIST_STYLE.borderless]: {
          image: {
            class: 'rounded-24',
            width: 120,
            height: 120,
          },
          buttons: {
            remove: {
              attrs: {
                height: 35,
                width: 35,
                'min-width': 35,
                class: 'ma-3',
              },
              icon: {
                size: 20,
              },
            },
          },
        },
      }[this.listStyle];
    },
  },
  methods: {
    closeImageDialog() {
      this.activeImage = null;
    },
    showImageDialog(image) {
      this.activeImage = image;
    },
  },
};
</script>
